"use strict";

import 'normalize.css';
import '../scss/style.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';
import Masonry from 'masonry-layout';

var hwo = {
  removeNoJs: null,
  faqExpand: null,
  setupMenu: null,
  menuToggle: null,
  projectCarousel: null,
  setupMaps: null,
  projectTabs: null,
  init: function() {
    this.removeNoJs(),
    this.setupMenu(),
    this.setUpFrontpageGrid(),
    this.videoSoundToggle(),
    this.projectCarousel(),
    this.projectTabs(),
    this.setupMaps()
  },


  removeNoJs: function() {
    document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, '') + ' js ';
  },

  setUpFrontpageGrid: function() {
    var grid = document.querySelector('.l-mosaic');
    if (!grid) return;
    new Masonry(grid, { itemSelector: '.l-mosaic__item' });
  },

  setupMenu: function() {
    var toggle = document.querySelector('.js-masthead__toggle');
    var html = document.getElementsByTagName('html')[0];

    toggle.addEventListener('click', function() {
      var isOpen = html.classList.toggle('has-masthead-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }, false);
  },

  videoSoundToggle: function() {

    if (document.querySelector('.c-hero__video')) {
      var videoHolder = document.querySelector('.c-hero__video');
      var video = videoHolder.getElementsByTagName('video')[0];
      video.addEventListener("click", function() {
        video.muted ? video.muted= false : video.muted= true;
        videoHolder.classList.toggle('js-video-muted');
      });
    }
  },

  projectCarousel: function () {
    if (document.querySelector('.swiper-container')) {

      var mySwiper = new Swiper('.swiper-container', {
        modules: [Navigation, Pagination, Keyboard],
        direction: 'horizontal',
        loop: true,

        pagination: {
          el: '.c-carousel__pagination',
          type: 'fraction',
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        on: {
          slideChange: function (el) {
            var slides = document.querySelectorAll('.swiper-slide');
            for (var i=0; i< slides.length; i ++) {
              var youtubePlayer = slides[i].querySelector('iframe');
            }
          },
        },
      });
    }
  },

  projectTabs: function() {
    var container = document.querySelector('.js-tabs');
    if (!container) return;

    var tabList = container.querySelector('[role="tablist"]');
    var tabs    = Array.from(container.querySelectorAll('[role="tab"]'));
    var panels  = Array.from(container.querySelectorAll('[role="tabpanel"]'));
    var slugs   = tabs.map(function(t) { return t.getAttribute('aria-controls'); });

    function activateTab(slug, moveFocus) {
      tabs.forEach(function(tab) {
        var active = tab.getAttribute('aria-controls') === slug;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        tab.classList.toggle('is-active', active);
      });
      panels.forEach(function(panel) {
        panel.classList.toggle('is-active', panel.id === slug);
      });
      if (moveFocus) {
        var activeTab = tabs.find(function(t) { return t.getAttribute('aria-controls') === slug; });
        if (activeTab) activeTab.focus();
      }
    }

    // Restore from URL hash or fall back to first tab
    var initial = window.location.hash.slice(1);
    activateTab(slugs.includes(initial) ? initial : slugs[0], false);

    // Click: update URL
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        var slug = this.getAttribute('aria-controls');
        activateTab(slug, false);
        history.pushState(null, '', '#' + slug);
      });
    });

    // Browser back / forward
    window.addEventListener('popstate', function() {
      var slug = window.location.hash.slice(1);
      if (slugs.includes(slug)) activateTab(slug, false);
    });

    // Keyboard: roving tabindex + arrow key navigation
    tabList.addEventListener('keydown', function(e) {
      var current = tabs.findIndex(function(t) { return t.getAttribute('aria-selected') === 'true'; });
      var next = current;
      switch (e.key) {
        case 'ArrowRight': case 'ArrowDown':  next = (current + 1) % tabs.length; break;
        case 'ArrowLeft':  case 'ArrowUp':    next = (current - 1 + tabs.length) % tabs.length; break;
        case 'Home': next = 0; break;
        case 'End':  next = tabs.length - 1; break;
        default: return;
      }
      e.preventDefault();
      var slug = tabs[next].getAttribute('aria-controls');
      activateTab(slug, true);
      history.pushState(null, '', '#' + slug);
    });
  },


  setupMaps: function() {
    if (document.querySelector('.js-map')) {
      if (typeof google !== 'undefined' && google.maps && google.maps.importLibrary) {
        this.initModernMaps();
      } else {
        if (typeof google !== 'undefined' && google.maps) {
          this.initLegacyMaps();
        }
      }
    }
  },

  initModernMaps: async function() {
    try {
      const { Map } = await google.maps.importLibrary("maps");
      const { Marker } = await google.maps.importLibrary("marker");

      var mymaps = document.querySelectorAll('.js-map');
      for (var i = 0; i < mymaps.length; i++) {
        var mymap = mymaps[i];
        var address = mymap.getAttribute('data-address');

        if (!address) continue;

        var map = new Map(mymap, {
          mapTypeId: 'terrain',
          zoom: 15,
          styles: [{ featureType: 'all', stylers: [{"saturation": -100}] }]
        });

        var contentString = '<div id="content">' +
            '<h1 id="mapHeading">HWO Architects</h1>' +
            '<div id="infoContent">' +
            '<address>' + address + '</address>' +
            '<a class="directions" href="https://www.google.com/maps/place/' + encodeURIComponent(address) + '">Get Directions</a>' +
            '</div></div>';

        var infowindow = new google.maps.InfoWindow({ content: contentString });

        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': address }, function(results, status) {
          if (status === 'OK' && results[0]) {
            var location = results[0].geometry.location;
            map.setCenter(location);
            var marker = new Marker({ position: location, map: map, title: 'HWO Architects' });
            marker.addListener('click', function() { infowindow.open(map, marker); });
          } else {
            console.error('Geocoder failed due to: ' + status);
          }
        });
      }
    } catch (error) {
      console.error('Error loading modern Google Maps:', error);
      this.initLegacyMaps();
    }
  },

  initLegacyMaps: function() {
    var mymaps = document.querySelectorAll('.js-map');
    for (var i = 0; i < mymaps.length; i++) {
      var mymap = mymaps[i];
      var address = mymap.getAttribute('data-address');
      if (!address) continue;

      var map = new google.maps.Map(mymap, {
        mapTypeId: google.maps.MapTypeId.TERRAIN,
        zoom: 15,
        styles: [{ featureType: 'all', stylers: [{"saturation": -100}] }]
      });

      var contentString = '<div id="content">' +
          '<h1 id="mapHeading">HWO Architects</h1>' +
          '<div id="infoContent">' +
          '<address>' + address + '</address>' +
          '<a class="directions" href="https://www.google.com/maps/place/' + encodeURIComponent(address) + '">Get Directions</a>' +
          '</div></div>';

      var infowindow = new google.maps.InfoWindow({ content: contentString });

      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': address }, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          var location = results[0].geometry.location;
          map.setCenter(location);
          var marker = new google.maps.Marker({ position: location, map: map, title: 'HWO Architects' });
          marker.addListener('click', function() { infowindow.open(map, marker); });
        } else {
          console.error('Legacy geocoder failed due to: ' + status);
        }
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
  document.addEventListener("touchstart", function() {}, true);
  hwo.init();
});
